import React from 'react';

import i18n from 'i18n-react';
import { HashLink as Link } from 'react-router-hash-link';

const params = new URLSearchParams(window.location.search);
let termsUri = '/main/rewards';
let mobile = false;
if (params.get('mobile')) {
  mobile = true;
  termsUri = '/main/rewards?mobile=true';
}

const TermsAndConditionsView = () => (
  <div className="contentContainer BookingForm TermsAndConditions">
    <div className="header">
      <h3>{i18n.translate('rewards.TermsAndConditions.title')}</h3>
    </div>
    <div className="bodyRewardsTerms">
      Remove page, link to https://www.visitlauderdale.com/terms-and-conditions/
    </div>

    {mobile && (
      <style>
        {
          '\
      .contentContainer { margin-top: 5rem; } .header { display: none; } .cookieConsent { display: none; }'
        }
      </style>
    )}
  </div>
);

export default TermsAndConditionsView;
